module.exports = __webpack_public_path__ + "img/email-quill.d34fe6e2.gif";